// @flow

// actions for the choice used in quiz & question set
const SELECT = 'choice:selection-changed';
const ANSWER = 'choice:answer';

const SKIP = 'choice:skip';
const BACK = 'choice:go-back';
const NEXT = 'choice:go-next';

const START_SESSION = 'choice:start-session';
const START_NEXT_BATCH = 'choice:start-nextbatch';
const STOP_SESSION = 'choice:stop-session';
const COMPLETE_SESSION = 'choice:session-complete';
const TOGGLE_CHECK_BOX = 'choice:session-toggle';
const SHOW = 'choice:show';
const REVIEW = 'choice:review';
const SET_TASK_IDS = 'choice:setTaskIds';
export {
  ANSWER,
  BACK,
  TOGGLE_CHECK_BOX,
  COMPLETE_SESSION,
  NEXT,
  SELECT,
  SKIP,
  SHOW,
  START_SESSION,
  STOP_SESSION,
  START_NEXT_BATCH,
  REVIEW,
  SET_TASK_IDS,
};
